<template>
  <div>
    <b-row
      v-if="data.length > 0"
      class="align-items-stretch"
    >
      <b-col
        v-for="(item, index) in data"
        :key="`${item.id}-${index}`"
        cols="12"
        md="6"
        lg="6"
        xl="4"
        class="d-flex  mb-4"
      >
        <b-card
          no-body
          class="card-developer-meetup w-100 h-100"
        >
          <!-- Imagen -->
          <div class="image-container p-2 rounded-top text-center">
            <b-img
              :src="(item.img && item.img.src) ? item.img.src : appLogoImage"
              :alt="(item.img && item.img.alt) ? item.img.alt : 'Indetec'"
              style="height: 100%; width: 100%; object-fit: cover;"
            />
          </div>

          <b-card-body class="d-flex flex-column">

            <!-- Nivel -->
            <b-row class="m-1">
              <b-col
                md="12"
                class="budget-wrapper"
              >
                <b-media no-body>
                  <b-media-aside class="mr-1">
                    <b-avatar
                      rounded
                      variant="light-primary"
                      size="20"
                    >
                      <feather-icon
                        icon="AlertCircleIcon"
                        size="18"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h5 class="mb-0">
                      <b>Nivel : {{ item.nivel }}</b>
                    </h5>
                  </b-media-body>
                </b-media>
              </b-col>
            </b-row>

            <!-- Header -->
            <div class="d-flex align-items-center">
              <b-card-title class="mb-0 mx-2">
                {{ item.nombre }}
              </b-card-title>
            </div>

            <!-- Botón -->
            <b-row class="mt-auto">
              <b-col
                lg="12"
                class="d-flex justify-content-between flex-column"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  :to="'/detalle-especialidad/' + item.id"
                >
                  Más información
                </b-button>
              </b-col>
            </b-row>

          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <div
      v-else
      class="text-center"
    >
      No hay resultados
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BCard, BImg, BCardBody, BCardTitle, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { timestampToDate, title } from '@core/utils/filter'
import appLogoImage from '@/assets/images/logo/logo.svg'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BImg,
    BCardBody,
    BCardTitle,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      timestampToDate,
      title,
      appLogoImage,
    }
  },
  setup() {
    const getCalendarDates = (arry, type) => arry.find(item => item.tipo === parseInt(type, 10))

    return {
      getCalendarDates,

      timestampToDate,
      title,
    }
  },
}
</script>
